import { GallerySettingsState } from '../../types/gallerySettings';

const getGallerySettings = (state: any): GallerySettingsState | undefined =>
  state.studio?.gallerySettings;

export const getSettings = (state: any) => getGallerySettings(state)?.settings || null;

export const getIsLoading = (state: any) => getGallerySettings(state)?.isLoading || false;

export const getError = (state: any) => getGallerySettings(state)?.error || null;

export const getIsSaving = (state: any) => getGallerySettings(state)?.isSaving || false;

export const getSaveError = (state: any) =>
  getGallerySettings(state)?.saveError || null;

export const getGalleries = (state: any) => getGallerySettings(state)?.galleries || [];
